import { View, Text, TouchableOpacity, StyleSheet } from 'react-native'
import { fontPalette, globalStyles } from '../../../static/styles/global'
import SelectKeyValue from '../../../components/shared/form/SelectKeyValue'
import HomeDetailsHeader from '../../../components/home/HomeDetailsHeader'
import Card from '../../../components/shared/card/Card'
import CardSeparator from '../../../components/shared/card/CardSeparator'
import moment from 'moment'
import { convertTo12HourTime, getLocalTimeWithTimezoneOffset, mapSelectKey } from '../../../utils'
import { usePersonalStore } from '../../../stores/personalInfo'
import { useEffect, useMemo, useState } from 'react'
import { useHomeStore } from '../../../stores/home'
import { useLabourStore } from '../../../stores/labour'
import { useclockstore } from '../../../stores/clock'
import SelectKeyValueCustom from '../../../components/shared/form/SelectKeyValueCustom'
import Toast from 'react-native-toast-message'
import { getCurrentLocationAndCheckQuadrilateral } from '../../../helpers/geoFencingHelper'
import { ActivityIndicator } from 'react-native-paper'
import { useTranslation } from 'react-i18next'
import { Loading } from '../../../components/shared/navigator/Loading'

const Transfer = ({ navigation, route }) => {
  const { params } = route
  const { mostRecentUserOnBoardings: userId, relationships, shiftid } = params

  const { t } = useTranslation()
  const [selecteddepartment, setSelectedDepartment] = useState('')

  const [disabled, setDisabled] = useState(true)

  const [currentTime, setCurrentTime] = useState(new Date())
  const { loading, error, personalData, fetchData, updateData } =
    usePersonalStore()
  const homestore = useHomeStore()
  const labourStore = useLabourStore()
  const clockstore = useclockstore()
  const personalstore = usePersonalStore()
  const [loader, setLoader] = useState(false)

  useEffect(() => {
    if (selecteddepartment) {
      setDisabled(false)
    }
  }, [selecteddepartment])

  const shiftdetails = useMemo(() => {
    return labourStore.scheduleData?.shiftInfo?.find((item: any) => item.shiftID == shiftid)
  }, [labourStore.scheduleData, shiftid])


  useEffect(() => {
    clockstore.fetchdepartments(
      personalstore.personalData.entityId,
      homestore.homeData.laborSaverStoreID,
      labourStore?.labourData?.userId ? labourStore?.labourData?.userId : 0
    )
    clockstore.fetchattendancelogkey(
      userId,
      shiftid,
      labourStore?.labourData?.employeeNumber,
      labourStore?.labourData?.userId ? labourStore?.labourData?.userId : 0
    )
  }, [])
  const Department = clockstore?.departmentsData?.data
  const homeStore = useHomeStore()

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentTime(new Date())
    }, 1000)

    return () => clearInterval(interval)
  }, [])

  const formattedTime = currentTime.toLocaleTimeString([], {
    hour: '2-digit',
    minute: '2-digit',
    hour12: true
  })

  const data = {
    essUserOnboardingKey: userId,
    attendanceLogKey: clockstore.attendancelogkey,
    outType: 'TRANSFER',
    Dept_focus: selecteddepartment.split('/')[0],
    Dept_LaborSaver: selecteddepartment.split('/')[1],
    satisfaction: '5',
    clockPunchTime: new Date().toISOString()
  }

  const handlesubmit = async () => {
    // const flag =
    //   !homestore.homeData?.geofencingStatus &&
    //   homestore.homeData?.coordinateOneLatitude != null
    // if (flag) {
    //   const topLeft = [
    //     homestore.homeData.coordinateOneLatitude,
    //     homestore.homeData.coordinateOneLongitude
    //   ]
    //   const topRight = [
    //     homestore.homeData.coordinateTwoLatitude,
    //     homestore.homeData.coordinateTwoLongitude
    //   ]
    //   const bottomRight = [
    //     homestore.homeData.coordinateThreeLatitude,
    //     homestore.homeData.coordinateThreeLongitude
    //   ]
    //   const bottomLeft = [
    //     homestore.homeData.coordinateFourLatitude,
    //     homestore.homeData.coordinateFourLongitude
    //   ]
    //   try {
    //     setLoader(true)
    //     const empLocation = null
    //     const res = await getCurrentLocationAndCheckQuadrilateral(
    //       topLeft,
    //       topRight,
    //       bottomLeft,
    //       bottomRight,
    //       empLocation
    //     )
    //     if (res) {
    //       try {
    //         if (parseInt(data.Dept_focus) != homestore.homeData.deptId) {
    //           await clockstore.updateclockin(data)
    //           await homeStore.fetchData(userId)
    //           navigation.navigate('LabourScreen')
    //         } else {
    //           Toast.show({
    //             type: 'error',
    //             position: 'bottom',
    //             text1: t('please select another store'),
    //             visibilityTime: 5000,
    //             autoHide: true,
    //             topOffset: 60
    //           })
    //         }
    //       } catch (error) { }
    //     } else {
    //       Toast.show({
    //         type: 'error',
    //         position: 'bottom',
    //         text1: t('Cannot submit Clock In from outside the store'),
    //         visibilityTime: 5000,
    //         autoHide: true,
    //         topOffset: 60
    //       })
    //     }
    //   } catch (error) {
    //     console.log(error)
    //   } finally {
    //     setLoader(false)
    //   }
    // } 
    // else {
    try {
      if (parseInt(data.Dept_focus) != clockstore?.departmentsData?.currentFocusDepartmentId) {
        await clockstore.updateclockin(data)
        await homeStore.fetchData(userId)
        navigation.navigate('LabourScreen')
      } else {
        Toast.show({
          type: 'error',
          position: 'bottom',
          text1: t('please select another department'),
          visibilityTime: 5000,
          autoHide: true,
          topOffset: 60
        })
      }
    } catch (error) { }
    // }
  }


  if (clockstore?.loading) return <Loading />

  return (
    <>
      <View style={[globalStyles.primaryBgColor, globalStyles.containerBand]}>
        <View style={[globalStyles.horizontalPadGap]}>
          <HomeDetailsHeader />
        </View>
        <View style={[globalStyles.vCenterItems]}>
          <Text
            style={[
              globalStyles.text,
              globalStyles.fwBold,
              globalStyles.fs30,
              globalStyles.whiteTextColor,
              globalStyles.textCenter
            ]}
          >
            {t('Transfer')}
          </Text>
          <TouchableOpacity
            style={{
              marginTop: 20,
              borderRadius: 5,
              backgroundColor: '#4FC7E8',
              width: '90%'
            }}
            onPress={() => navigation.navigate('LabourScreen')}
          >
            <Text
              style={{
                color: 'white',
                fontSize: 20,
                textAlign: 'center',
                padding: 10,
                fontFamily:fontPalette.primaryBold
              }}
            >
              {t('cancel')}
            </Text>
          </TouchableOpacity>
        </View>
      </View>
      <View
        style={{
          marginTop: -44,
          padding: 16,
          flex: 1,
          justifyContent: 'space-between'
        }}
      >
        <Card>
          <View>
            <Text style={{ fontSize: 30, fontWeight: 'bold',fontFamily:fontPalette.primaryBold }}>
              {formattedTime}
            </Text>
            <CardSeparator />

            <Text
              style={[
                globalStyles.inputLabel,
                globalStyles.inputLabelLarge,
                globalStyles.inputLabelPrimary,

              ]}
            >
              {t('Shift')}
            </Text>
            <Text style={{ fontSize: 18,fontFamily:fontPalette.primaryRegular }}>
              {moment(shiftdetails?.date).format('MMM D')},{' '}
              {convertTo12HourTime(shiftdetails?.time_In)} -{' '}
              {convertTo12HourTime(shiftdetails?.time_Out)}
            </Text>
            <View style={[{ width: '100%', marginRight: '2%' }]}>
              <Text
                style={[
                  globalStyles.inputLabel,
                  globalStyles.inputLabelLarge,
                  globalStyles.inputLabelPrimary,
                  { marginTop: 10 }
                ]}
              >
                {t('store')}
              </Text>
              <Text style={{ fontSize: 18,fontFamily:fontPalette.primaryRegular }}>
                {homestore?.homeData?.storeName}
              </Text>
            </View>

            <View style={[{ width: '100%', marginRight: '2%' }]}>
              <Text
                style={[
                  globalStyles.inputLabel,
                  globalStyles.inputLabelLarge,
                  globalStyles.inputLabelPrimary,
                  { marginTop: 10 }
                ]}
              >
                {t('Department')}
              </Text>
            </View>
            {Department && Department.length > 0 && (
              <SelectKeyValueCustom
                title={t('Department')}
                options={Department}
                selectedOption={mapSelectKey(Department, selecteddepartment)}
                onSelect={(option: string) => {
                  setSelectedDepartment(option)
                }}
              />
            )}
          </View>
        </Card>
        {loader && <ActivityIndicator />}
        {!loader && (
          <TouchableOpacity
            style={[
              styles.custom2,
              { backgroundColor: disabled ? '#CCCCCC' : '#9DD086' }
            ]}
            disabled={disabled}
            onPress={handlesubmit}
          >
            <View>
              <Text
                style={{ fontSize: 20, color: 'white' ,fontFamily:fontPalette.primaryBold}}
              >
                {t('Confirm Transfer')}
              </Text>
            </View>
          </TouchableOpacity>
        )}
      </View>

    </>
  )
}
export default Transfer

const styles = StyleSheet.create({
  custom: {
    justifyContent: 'center',
    flexDirection: 'row',
    paddingLeft: 16,
    paddingRight: 16,
    height: 40,
    width: '90%',
    alignItems: 'center',
    backgroundColor: '#0088CF',
    color: 'black',
    borderWidth: 0,
    borderRadius: 11
  },
  custom2: {
    justifyContent: 'center',
    flexDirection: 'row',
    height: 40,
    width: '95%',
    paddingLeft: 16,
    paddingRight: 16,
    alignItems: 'center',
    alignSelf: 'center',
    borderWidth: 0,
    borderRadius: 10
  }
})
